"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.LayoutWrapper = exports.Header = exports.BodyLoading = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var LayoutWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-family: 'Muli', sans-serif;\n    font-size: ", ";\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n\n    .ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw {\n        width: 250px;\n    }\n\n    .ck.ck-toolbar-dropdown .ck.ck-toolbar .ck.ck-toolbar__items {\n        flex-wrap: wrap;\n    }\n"])), function (props) {
  return props.theme.admin.font.size;
});

exports.LayoutWrapper = LayoutWrapper;

var Header = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-basis: 40px;\n    padding: 0px 15px;\n    background-color: ", ";\n    z-index: 20;\n"])), function (props) {
  return props.theme.admin.colors.brandDark;
});

exports.Header = Header;

var Wrapper = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    flex: 1;\n    display: flex;\n    width: 100%;\n    height: 100%;\n"])));

exports.Wrapper = Wrapper;

var BodyLoading = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    flex: 1;\n    overflow: hidden auto;\n    height: calc(100vh - 40px);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n"])));

exports.BodyLoading = BodyLoading;